<template>
  <section class="ferramentas-estudo">
    <div id="ferramentas">
      <div class="container">
        <div class="titulo" v-if="!ferramentaAtiva">
            <span>Ferramentas de aprendizado</span>
        </div>
        <div v-else class="botoes-navegacao">
            <a class="btn btn-voltar" @click="voltarFerramenta"><i class="fas fa-long-arrow-alt-left"></i></a>
            <a class="btn btn-ferramenta" @click="alternaFerramenta('resumos')" v-if="ferramentaAtiva != 'resumos'"><i class="fas fa-file-alt"></i> <b class="label-ferramenta">Resumos</b></a>
            <a class="btn btn-ferramenta" @click="alternaFerramenta('modelos-3d')" v-if="ferramentaAtiva != 'modelos-3d'"><img :src="coracaoCinzaModelos3D" class="img-fluid modelo3DIcone" /> <b class="label-ferramenta">Modelos 3D</b></a>
            <a class="btn btn-ferramenta" @click="alternaFerramenta('mapas-mentais')" v-if="ferramentaAtiva != 'mapas-mentais'"><i class="fas fa-code-branch"></i> <b class="label-ferramenta">Mapas Mentais</b></a>
        </div>
        <div class="busca">
          <div class="row mb-4">
            <div class="banner" v-if="!ferramentaAtiva" :style="{ 'background-image': 'url(' + flashcardsBackground + ')' }">
              <a class="btn-div" href="/flashcards">Conheça<br>os Flashcards</a>
            </div>
            <div v-else class="apenas-ferramenta" id="apenas-ferramenta"> Apenas <br>{{ nomeAtivo }}</div>
            <div class="search-menu">
              <form>
                <div class="search">
                  <input type="text" class="search-term" placeholder="O que você quer estudar hoje?" v-model="termoPesquisa">
                  <button type="submit" class="btn btn-primary" @click="buscaGeralPlataforma">
                    Buscar
                  </button>
                </div>
                <div>
                  <table class="tags-buscados">
                    <tr>
                      <td>Mais buscados</td>
                      <td>
                        <div class="tags row">
                          <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Farmacologia')">Farmacologia</a>
                          <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Semiologia')">Semiologia</a>
                          <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Pediatria')">Pediatria</a>
                          <div class="tags-buscados-desktop">
                            <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Suseme')">Suseme</a>
                            <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Anatomia')">Anatomia</a>
                            <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Fisiologia')">Fisiologia</a>
                            <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Embriologia')">Embriologia</a>
                            <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Imunologia')">Imunologia</a>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </form>
            </div>
            <div class="lista-carrossel" v-if="ferramentaAtiva">
              <ferramentas-carousel :key="'key - ' + ferramentaAtiva" :ferramentas="ferramentasItem" :ferramenta="ferramentaAtiva"></ferramentas-carousel>
            </div>
          </div>
          <div class="row ferramentas" v-if="!ferramentaAtiva">
            <div class="col-4 item-ferramenta" :style="{ 'background-image': 'url(' + modelos3DBackground + ')' }">
              <a class="btn-div" @click="alternaFerramenta('modelos-3d')" ><img :src="coracaoBrancoModelos3D" class="img-fluid modelo3DIcone" /> Modelos 3D</a>
            </div>
            <div class="col-4 item-ferramenta" :style="{ 'background-image': 'url(' + mapasMentaisBackground + ')' }">
              <a class="btn-div" @click="alternaFerramenta('mapas-mentais')" ><i class="fas fa-code-branch"></i> Mapas Mentais</a>
            </div>
            <div class="col-4 item-ferramenta" :style="{ 'background-image': 'url(' + resumosBackground + ')' }">
              <a class="btn-div" @click="alternaFerramenta('resumos')" ><i class="fas fa-file-alt"></i> Resumos</a>
            </div>
          </div>
        </div>
      </div>
      <div class="lista-ferramentas" v-if="ferramentaAtiva">
        <ferramentas-item :ferramenta="ferramentaAtiva" :conteudo="conteudoAtivo"></ferramentas-item>
      </div>
      <div class="lista-carrossel" v-if="!ferramentaAtiva && ferramentas" ref="listaCarrosel">
        <ferramentas-carousel :ferramentas="ferramentas" :ferramenta="null" @alterna-ferramenta="alternaFerramenta"></ferramentas-carousel>
      </div>
    </div>
  </section>
</template>

<script>
import FerramentasItem from './components/FerramentasItem'
import FerramentasCarousel from './components/FerramentasCarousel'
import FerramentaAPI from '@/api/ferramentas-api'
export default {
  name: 'FerramentasView',
  components: {
    FerramentasItem,
    FerramentasCarousel
  },
  data () {
    return {
      ferramentaAtiva: null,
      termoPesquisa: null,
      modelos3d: null,
      mapasMentais: null,
      resumos: null,
      conteudoAtivo: [],
      nomeAtivo: null,
      ferramentas: null,
      ferramentasItem: null,
      maisAcessados: null
    }
  },
  async beforeMount () {
    const loader = this.$loading.show()
    this.ferramentas = await FerramentaAPI.listarFerramentas()
    loader.hide()
    this.ferramentaAtiva = this.$store.getters.getFerramentaAtiva
    this.nomeAtivo = this.$store.getters.getFerramentaNome
  },
  computed: {
    flashcardsBackground: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}topicos-imagem/60a507bc64775_flashcards.png`
    },
    modelos3DBackground: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}topicos-imagem/60a507ba2f4fa_modelos%203d.png`
    },
    mapasMentaisBackground: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}topicos-imagem/60a507bbc1948_mapas%20mentais.png`
    },
    resumosBackground: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}topicos-imagem/60a507bc00acd_resumos.png`
    },
    coracaoBrancoModelos3D: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/heart-branco.png`
    },
    coracaoCinzaModelos3D: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/heart-cinza.png`
    }
  },
  methods: {
    aplicarTermoPesquisaMaisBuscados: function (termoMaisBuscado) {
      this.termoPesquisa = termoMaisBuscado
      this.buscaGeralPlataforma()
    },
    buscaGeralPlataforma: function (event) {
      this.$store.dispatch('buscaGeralPlataforma', this.termoPesquisa)
      this.$router.push(`/busca?q=${this.termoPesquisa}`)
    },
    alternaFerramenta: async function (ferramenta) {
      this.maisAcessados = await FerramentaAPI.listarMaisAcessados(ferramenta)
      this.maisAcessados = { maisAcessados: this.maisAcessados }
      this.ferramentasItem = this.ferramentas
      Object.assign(this.ferramentasItem, this.maisAcessados)
      this.$store.dispatch('alternaFerramenta', ferramenta)
    },
    voltarFerramenta: async function () {
      this.ferramentas = await FerramentaAPI.listarFerramentas()
      this.ferramentaAtiva = null
      this.nomeAtivo = null
      this.$store.dispatch('alternaFerramenta', 'todas')
    }
  },
  watch: {
    '$store.getters.getFerramentaNome': function () {
      this.ferramentaAtiva = this.$store.getters.getFerramentaAtiva
      this.nomeAtivo = this.$store.getters.getFerramentaNome
    }
  }
}
</script>
